export default __webpack_public_path__ + "static/media/step3-assessment-results.af5ba3d2.gif";